import {Pipe, PipeTransform} from "@angular/core";
import {DatePipe} from "@angular/common";

@Pipe({name: 'clearTimezone'})
export class ClearTimezonePipe extends DatePipe implements PipeTransform {

  transform(dateToOffset: string): any {
    let offsetDate = new Date(dateToOffset);
    let date = new Date();

    const userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
    offsetDate = new Date(offsetDate.getTime() + userTimezoneOffset);
    return offsetDate.getTime();
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/clear-timezone.pipe.ts